export function uuid () {
  return Math.random().toString(17).slice(2)
}

export const isInvalidContent = (field = '') => {
  const isNull = field === null
  const isUndefined = field === undefined
  const isEmpty = !isNull && !isUndefined && field.trim().length === 0

  return isNull || isUndefined || isEmpty
}

export const getBackgroundImageByIndex = (images = [], index = 0, field = 'background') => {
  return images && images[field] &&
    Array.isArray(images[field]) &&
    images[field].length > index &&
    images[field][index] &&
    images[field][index].url_image ? images[field][index].url_image : ''
}

const validateDisplaySection = (opportunitySettings = [], exportType = '', sectionId = 0) => {
  if (opportunitySettings === undefined || opportunitySettings === null) return true
  const exportSettings = opportunitySettings.find(setting => {
    return setting.type === exportType
  })
  if (exportSettings === undefined || exportSettings === null) return true
  const contentFound = exportSettings && exportSettings.contents.find(section => {
    return section.id_content === sectionId
  })
  return contentFound !== undefined
}

export const helpers = {
  isInvalidContent,
  getBackgroundImageByIndex,
  validateDisplaySection
}
